import React from "react";
import "./Business.css";


// Pending Images Upload

function Business(){

    return(
        <div className="contents">
  <div className="container">
  {/* <!-- Row 1: Three Cards --> */}
  <div className="row justify-content-center g-4">
    <div className="col-md-4">
      <div className="cardid card border border-dark">

                      <div className="corner-circle"></div>

        <div className="card-body">
          <h5 className="card-title">
              <img src="socialmedia.png" alt="Logo"/>
        Business Strategy Consulting</h5>
          <p className="card-text">We help you define clear goals, identify growth opportunities, and build practical strategies that align with your vision. Our expert consultants analyze your current position<br/>
           and guide you with actionable business roadmaps to boost revenue, reduce risks, and stay ahead in your industry.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className=" cardid card  border border-dark">

                      <div className="corner-circle "></div>

        <div className="card-body">
         <h5 className="card-title">
        <img src="searchengine.png" alt="Logo"/>
             Market Research & Analysis</h5>
          <p className="card-text">
        We conduct in-depth research to help you understand your market, target audience, and competition. Through data-driven insights, we support you in making smart marketing, pricing, and product decisions.<br/>
         Our research empowers your business with the clarity needed to succeed in a competitive environment.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="Google.png" alt="Logo"/>
        Financial & Budget Planning</h5>
          <p className="card-text">We assist businesses in managing finances effectively by offering professional budgeting, forecasting, and investment planning services. Whether you're a startup or a growing company, we guide you to maintain financial<br/>
           health and long-term profitability with smart, sustainable planning.</p>
        </div>
      </div>
    </div>
  </div>

  <div className="row justify-content-center g-4 mt-3">
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="content.png" alt="Logo"/>
          Operational Efficiency Consulting</h5>
          <p className="card-text">Our consultants work with you to streamline your internal processes, reduce waste, and improve team productivity.<br/>
           We help implement systems and workflows that make your business more agile, efficient, and ready to scale without chaos.</p>
        </div>
      </div>
    </div>
    <div className="col-md-4">
      <div className="cardid card  border border-dark">

                              <div className="corner-circle "></div>

        <div className="card-body">
          <h5 className="card-title">
          <img src="email.png" alt="Logo"/>
        Startup & Business Growth Advisory</h5>
          <p className="card-text">From launching a new venture to scaling an existing business, we provide complete support throughout your journey. We help with business planning, brand positioning, compliance, and strategic growth so you can build a strong foundation and expand with confidence.</p>
        </div>
      </div>
    </div>
  </div>
</div>


<button type="button" className="exitbutton btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Move to Previous
</button>


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Exit page</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      Are You Really want to Exit this page..
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary">Yes</button>
      </div>
    </div>
  </div>
</div>


        </div>
    )

}
export default Business;